module.exports = __webpack_public_path__ + "fonts/890bd988-5306-43ff-bd4b-922bc5ebdeb4.16071ef.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/890bd988-5306-43ff-bd4b-922bc5ebdeb4.ttf
// module id = 167
// module chunks = 245 246